document.addEventListener("DOMContentLoaded", function () {
	const submitButton = document.querySelector("product-form .atc-button.product-form__submit");
	if (submitButton) {
		submitButton.addEventListener("click", function (e) {
			const interval = setInterval(() => {
				if (!submitButton.classList.contains("loading")) {
					clearInterval(interval);
					const cartContents = fetch(window.Shopify.routes.root + "cart.js")
						.then((response) => response.json())
						.then((data) => {
							const cartItems = data.items;
							let updates = {};
							let bundleProducts = [];
							const selectedVariant = document.querySelector("product-form .product-variant-id").value;
							const selectedItem = cartItems.filter((product) => product.id == selectedVariant)[0].handle;

							cartItems.forEach((cartItem) => {
								if (cartItem.discounted_price === 0) {
									const freeItemID = cartItem.id;
									updates[`${freeItemID}`] = 1;
								}
							});
							const gifts = document.querySelectorAll("quantity-gifts .quantity-gift");
							gifts.forEach((gift) => {
								const giftIndex = gift.dataset.quantity;
								bundleProducts.push(gift.dataset.product);
							});
							fetch(window.Shopify.routes.root + "cart/update.js", {
								method: "POST",
								headers: {
									"Content-Type": "application/json",
								},
								body: JSON.stringify({ updates }),
							})
								.then((response) => response.json())
								.then((data) => {
									const cartCount = document.querySelectorAll("header .header__icon--cart .cart-count-bubble span");
									cartCount[0].innerHTML = data.item_count;
									const cartDrawerHeading = document.querySelector("#CartDrawer .drawer__heading");
									cartDrawerHeading.innerHTML = `Cart • ${data.item_count} items`;
								});
							fetch(window.Shopify.routes.root + "cart/update.js", {
								method: "POST",
								headers: {
									"Content-Type": "application/json",
								},

								body: `{ "attributes": { "${selectedItem}": "${[...bundleProducts]}" } }`,
							})
								.then((response) => response.json())
								.then((data) => {
									const cartAttributes = data.attributes;
									const freeItemsID = Object.values(cartAttributes)[0].split(",");
									const cartCount = document.querySelector("header .header__icon--cart");
									let currentProductQuantity = data.items.reduce((counter, product) => {
										if (product.handle == Object.keys(cartAttributes).toString()) {
											counter = counter + product.quantity;
										}
										return counter;
									}, 0);
									let updates = {};
									let firstProduct = freeItemsID[0],
										secondProduct = freeItemsID[1],
										thirdProduct = freeItemsID[2];

									if (currentProductQuantity === 1) {
										updates = {
											[firstProduct]: 1,
											[secondProduct]: 0,
											[thirdProduct]: 0,
										};

										fetch(window.Shopify.routes.root + "cart/update.js", {
											method: "POST",
											headers: {
												"Content-Type": "application/json",
											},
											body: JSON.stringify({ updates }),
										})
											.then((response) => {
												return response.json();
											})
											.then((data) => {
												fetch(`${window.location.href}?shopify-section-cart-drawer`)
													.then((response) => response.text())
													.then((responseText) => {
														const html = new DOMParser().parseFromString(responseText, "text/html");
														const cartDrawerNew = html.querySelector("#shopify-section-cart-drawer cart-drawer");
														cartDrawerSection.innerHTML = cartDrawerNew.innerHTML;
														const cartCountNew = html.querySelector("header .header__icon--cart");
														cartCount.innerHTML = cartCountNew.innerHTML;
													});
											})
											.catch((error) => {
												console.error("Error:", error);
											});
									} else if (currentProductQuantity === 2) {
										updates = {
											[firstProduct]: 1,
											[secondProduct]: 1,
											[thirdProduct]: 0,
										};

										fetch(window.Shopify.routes.root + "cart/update.js", {
											method: "POST",
											headers: {
												"Content-Type": "application/json",
											},
											body: JSON.stringify({ updates }),
										})
											.then((response) => {
												return response.json();
											})
											.then((data) => {
												fetch(`${window.location.href}?shopify-section-cart-drawer`)
													.then((response) => response.text())
													.then((responseText) => {
														const html = new DOMParser().parseFromString(responseText, "text/html");
														const cartDrawerNew = html.querySelector("#shopify-section-cart-drawer cart-drawer");
														cartDrawerSection.innerHTML = cartDrawerNew.innerHTML;
														const cartCountNew = html.querySelector("header .header__icon--cart");
														cartCount.innerHTML = cartCountNew.innerHTML;
													})
													.catch((e) => {
														console.error(e);
													});
											})
											.catch((error) => {
												console.error("Error:", error);
											});
									} else {
										updates = {
											[firstProduct]: 1,
											[secondProduct]: 1,
											[thirdProduct]: 1,
										};
										fetch(window.Shopify.routes.root + "cart/update.js", {
											method: "POST",
											headers: {
												"Content-Type": "application/json",
											},
											body: JSON.stringify({ updates }),
										})
											.then((response) => {
												return response.json();
											})
											.then((data) => {
												fetch(`${window.location.href}?shopify-section-cart-drawer`)
													.then((response) => response.text())
													.then((responseText) => {
														const html = new DOMParser().parseFromString(responseText, "text/html");
														const cartDrawerNew = html.querySelector("#shopify-section-cart-drawer cart-drawer");
														cartDrawerSection.innerHTML = cartDrawerNew.innerHTML;
														const cartCountNew = html.querySelector("header .header__icon--cart");
														cartCount.innerHTML = cartCountNew.innerHTML;
													})
													.catch((e) => {
														console.error(e);
													});
											})
											.catch((error) => {
												console.error("Error:", error);
											});
									}
								});
						});
				}
			}, 50);
		});
	}
	const cartDrawer = document.querySelector("cart-drawer");
	const cartDrawerSection = document.querySelector("#shopify-section-cart-drawer cart-drawer");
	// =======================================================
	if (cartDrawer) {
		cartDrawer.addEventListener("click", function (e) {
			if (e.target.closest("cart-drawer quantity-input")) {
				const currentProduct = e.target.closest(".cart-drawer-item").dataset.product;
				const cartCount = document.querySelector("header .header__icon--cart");
				const interval = setInterval(() => {
					const cartDrawerItemsWrapper = document.querySelector("#CartDrawer-CartItems");
					if (!cartDrawerItemsWrapper.classList.contains("cart__items--disabled")) {
						clearInterval(interval);
						const cartContents = fetch(window.Shopify.routes.root + "cart.js")
							.then((response) => response.json())
							.then((data) => {
								const cartAttributes = data.attributes;
								const freeItemsID = Object.values(cartAttributes)[0].split(",");

								let currentProductQuantity = data.items.reduce((counter, product) => {
									if (product.handle == Object.keys(cartAttributes).toString()) {
										counter = counter + product.quantity;
									}
									return counter;
								}, 0);
								let updates = {};
								let firstProduct = freeItemsID[0],
									secondProduct = freeItemsID[1],
									thirdProduct = freeItemsID[2];

								if (currentProductQuantity === 1) {
									updates = {
										[firstProduct]: 1,
										[secondProduct]: 0,
										[thirdProduct]: 0,
									};

									fetch(window.Shopify.routes.root + "cart/update.js", {
										method: "POST",
										headers: {
											"Content-Type": "application/json",
										},
										body: JSON.stringify({ updates }),
									})
										.then((response) => {
											return response.json();
										})
										.then((data) => {
											fetch(`${window.location.href}?shopify-section-cart-drawer`)
												.then((response) => response.text())
												.then((responseText) => {
													const html = new DOMParser().parseFromString(responseText, "text/html");
													const cartDrawerNew = html.querySelector("#shopify-section-cart-drawer cart-drawer");
													cartDrawerSection.innerHTML = cartDrawerNew.innerHTML;
													const cartCountNew = html.querySelector("header .header__icon--cart");
													cartCount.innerHTML = cartCountNew.innerHTML;
												});
										})
										.catch((error) => {
											console.error("Error:", error);
										});
								} else if (currentProductQuantity === 2) {
									updates = {
										[firstProduct]: 1,
										[secondProduct]: 1,
										[thirdProduct]: 0,
									};

									fetch(window.Shopify.routes.root + "cart/update.js", {
										method: "POST",
										headers: {
											"Content-Type": "application/json",
										},
										body: JSON.stringify({ updates }),
									})
										.then((response) => {
											return response.json();
										})
										.then((data) => {
											fetch(`${window.location.href}?shopify-section-cart-drawer`)
												.then((response) => response.text())
												.then((responseText) => {
													const html = new DOMParser().parseFromString(responseText, "text/html");
													const cartDrawerNew = html.querySelector("#shopify-section-cart-drawer cart-drawer");
													cartDrawerSection.innerHTML = cartDrawerNew.innerHTML;
													const cartCountNew = html.querySelector("header .header__icon--cart");
													cartCount.innerHTML = cartCountNew.innerHTML;
												})
												.catch((e) => {
													console.error(e);
												});
										})
										.catch((error) => {
											console.error("Error:", error);
										});
								} else {
									updates = {
										[firstProduct]: 1,
										[secondProduct]: 1,
										[thirdProduct]: 1,
									};
									fetch(window.Shopify.routes.root + "cart/update.js", {
										method: "POST",
										headers: {
											"Content-Type": "application/json",
										},
										body: JSON.stringify({ updates }),
									})
										.then((response) => {
											return response.json();
										})
										.then((data) => {
											fetch(`${window.location.href}?shopify-section-cart-drawer`)
												.then((response) => response.text())
												.then((responseText) => {
													const html = new DOMParser().parseFromString(responseText, "text/html");
													const cartDrawerNew = html.querySelector("#shopify-section-cart-drawer cart-drawer");
													cartDrawerSection.innerHTML = cartDrawerNew.innerHTML;
													const cartCountNew = html.querySelector("header .header__icon--cart");
													cartCount.innerHTML = cartCountNew.innerHTML;
												})
												.catch((e) => {
													console.error(e);
												});
										})
										.catch((error) => {
											console.error("Error:", error);
										});
								}
							});
					}
				}, 300);
			}
			if (e.target.closest("cart-remove-button")) {
				const interval = setInterval(() => {
					const cartDrawerItemsWrapper = document.querySelector("#CartDrawer-CartItems");
					const cartCount = document.querySelector("header .header__icon--cart");
					if (!cartDrawerItemsWrapper.classList.contains("cart__items--disabled")) {
						clearInterval(interval);
						const cartContents = fetch(window.Shopify.routes.root + "cart.js")
							.then((response) => response.json())
							.then((data) => {
								const paidProducts = data.items.filter((product) => product.discounted_price != 0);

								if (paidProducts.length == 0) {
									cartDrawerSection.querySelector("#CartDrawer").classList.add("rendering");

									fetch(window.Shopify.routes.root + "cart/clear.js")
										.then((response) => response.json())
										.then((data) => {
											fetch(`${window.location.href}?shopify-section-cart-drawer`)
												.then((response) => response.text())
												.then((responseText) => {
													const html = new DOMParser().parseFromString(responseText, "text/html");
													const cartDrawerNew = html.querySelector("#shopify-section-cart-drawer cart-drawer");
													cartDrawerSection.innerHTML = cartDrawerNew.innerHTML;
													cartDrawerSection.classList.add("is-empty");
													cartDrawerSection.classList.add("active");
													const cartCountNew = html.querySelector("header .header__icon--cart");
													cartCount.innerHTML = cartCountNew.innerHTML;
												})
												.catch((e) => {
													console.error(e);
												});
										});
								} else {
									const cartAttributes = data.attributes;
									const freeItemsID = Object.values(cartAttributes)[0].split(",");

									let currentProductQuantity = data.items.reduce((counter, product) => {
										if (product.handle == Object.keys(cartAttributes).toString()) {
											counter = counter + product.quantity;
										}
										return counter;
									}, 0);
									let updates = {};
									let firstProduct = freeItemsID[0],
										secondProduct = freeItemsID[1],
										thirdProduct = freeItemsID[2];

									if (currentProductQuantity === 1) {
										updates = {
											[firstProduct]: 1,
											[secondProduct]: 0,
											[thirdProduct]: 0,
										};

										fetch(window.Shopify.routes.root + "cart/update.js", {
											method: "POST",
											headers: {
												"Content-Type": "application/json",
											},
											body: JSON.stringify({ updates }),
										})
											.then((response) => {
												return response.json();
											})
											.then((data) => {
												fetch(`${window.location.href}?shopify-section-cart-drawer`)
													.then((response) => response.text())
													.then((responseText) => {
														const html = new DOMParser().parseFromString(responseText, "text/html");
														const cartDrawerNew = html.querySelector("#shopify-section-cart-drawer cart-drawer");
														cartDrawerSection.innerHTML = cartDrawerNew.innerHTML;
														const cartCountNew = html.querySelector("header .header__icon--cart");
														cartCount.innerHTML = cartCountNew.innerHTML;
													});
											})
											.catch((error) => {
												console.error("Error:", error);
											});
									} else if (currentProductQuantity === 2) {
										updates = {
											[firstProduct]: 1,
											[secondProduct]: 1,
											[thirdProduct]: 0,
										};

										fetch(window.Shopify.routes.root + "cart/update.js", {
											method: "POST",
											headers: {
												"Content-Type": "application/json",
											},
											body: JSON.stringify({ updates }),
										})
											.then((response) => {
												return response.json();
											})
											.then((data) => {
												fetch(`${window.location.href}?shopify-section-cart-drawer`)
													.then((response) => response.text())
													.then((responseText) => {
														const html = new DOMParser().parseFromString(responseText, "text/html");
														const cartDrawerNew = html.querySelector("#shopify-section-cart-drawer cart-drawer");
														cartDrawerSection.innerHTML = cartDrawerNew.innerHTML;
														const cartCountNew = html.querySelector("header .header__icon--cart");
														cartCount.innerHTML = cartCountNew.innerHTML;
													})
													.catch((e) => {
														console.error(e);
													});
											})
											.catch((error) => {
												console.error("Error:", error);
											});
									} else {
										updates = {
											[firstProduct]: 1,
											[secondProduct]: 1,
											[thirdProduct]: 1,
										};
										fetch(window.Shopify.routes.root + "cart/update.js", {
											method: "POST",
											headers: {
												"Content-Type": "application/json",
											},
											body: JSON.stringify({ updates }),
										})
											.then((response) => {
												return response.json();
											})
											.then((data) => {
												fetch(`${window.location.href}?shopify-section-cart-drawer`)
													.then((response) => response.text())
													.then((responseText) => {
														const html = new DOMParser().parseFromString(responseText, "text/html");
														const cartDrawerNew = html.querySelector("#shopify-section-cart-drawer cart-drawer");
														cartDrawerSection.innerHTML = cartDrawerNew.innerHTML;
														const cartCountNew = html.querySelector("header .header__icon--cart");
														cartCount.innerHTML = cartCountNew.innerHTML;
													})
													.catch((e) => {
														console.error(e);
													});
											})
											.catch((error) => {
												console.error("Error:", error);
											});
									}
								}
							});
					}
				}, 100);
			}
		});
	}
});
